import { TInvoiceReportDetailFormInputsResponse } from '@/context/services/reportsType/invoiceReports/type';
import { findReportFormInputType } from '@/context/services/reportsType/invoiceReports/useConvertApiDataAndPayeeForm';
import { useMemo } from 'react';

export const useFindInvoicePayeeId = (
  reportFormInputs: TInvoiceReportDetailFormInputsResponse[]
) => {
  return useMemo(
    () =>
      findReportFormInputType(
        reportFormInputs,
        'ApReportFormInputInvoicePayeeType'
      )!,
    [reportFormInputs]
  );
};

export const useHasInvoicePayee = (
  reportFormInputs: TInvoiceReportDetailFormInputsResponse[]
) => {
  return useMemo(
    () =>
      !!findReportFormInputType(
        reportFormInputs,
        'ApReportFormInputInvoicePayeeType'
      )?.id ||
      !!findReportFormInputType(
        reportFormInputs,
        'ApReportFormInputInvoiceInstantPayee'
      )?.id,
    [reportFormInputs]
  );
};

export const useFindInvoiceFileId = (
  reportFormInputs: TInvoiceReportDetailFormInputsResponse[]
) => {
  return (
    useMemo(
      () =>
        findReportFormInputType(
          reportFormInputs,
          'ApReportFormInputInvoiceFileField'
        )?.id,
      [reportFormInputs]
    ) ?? ''
  );
};

export const useFindSpecialException = (
  reportFormInputs: TInvoiceReportDetailFormInputsResponse[]
) => {
  return (
    useMemo(
      () =>
        findReportFormInputType(
          reportFormInputs,
          'ApReportFormInputSpecialExceptionStatus'
        )?.id,
      [reportFormInputs]
    ) ?? ''
  );
};

export const useFindInvoiceRegistrationNumber = (
  reportFormInputs: TInvoiceReportDetailFormInputsResponse[]
) => {
  return (
    useMemo(() => {
      const invoiceRegistrationNumber = findReportFormInputType(
        reportFormInputs,
        'ApReportFormInputInvoiceRegistrationNumberField'
      );

      return {
        id: invoiceRegistrationNumber?.id,
        isHidden: invoiceRegistrationNumber?.is_hidden,
      };
    }, [reportFormInputs]) ?? ''
  );
};
